<div class="panel widget" *ngIf="(groups && groups.length > 0) || working">
    <div class="panel-heading-flex">
        <div class="panel-title no-uppercase">
            Authority Documents Requiring Acknowledgement
        </div>
        <div class="panel-content"></div>
        <div class="panel-buttons">
            <button
                class="btn btn-inline"
                (click)="onToggleCollapse()"
                [tooltip]="showBody ? 'Hide' : 'Show'"
                placement="left"
            >
                <i *ngIf="showBody" class="fa-chevron-up fa no-border"></i>
                <i *ngIf="!showBody" class="fa-chevron-down fa no-border"></i>
            </button>
        </div>
    </div>
    <div *ngIf="showBody" class="panel-body" @expandOnEnter @collapseOnLeave>
        <ng-container *ngFor="let group of groups">
            <h4 class="section-heading">
                <span>{{ group.sourceName }}</span>
                <div></div>
            </h4>
            <attachment-list
                [attachmentsHandler]="group.handler"
                [allowUploads]="false"
                [allowDelete]="false"
                [allowEdit]="false"
                [allowAcknowledgements]="true"
                [requestingOrganisationId]="organisation.id"
                permissions
            ></attachment-list>
        </ng-container>
        <loading-indicator [isLoading]="working"></loading-indicator>
    </div>
</div>
<completed-outstanding-tasks-banner
    *ngIf="(!groups || groups.length === 0) && !working"
    widgetHeading="Authority Documents Requiring Acknowledgement"
></completed-outstanding-tasks-banner>
